import * as z from "zod";

export const getReturnsProcessingMetrics = {
  name: "getReturnsProcessingMetrics" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    comparisonStartDate: z.coerce.date(),
    comparisonEndDate: z.coerce.date(),
    merchantTeamId: z.string().optional(),
  }),
  output: z.object({
    totalReturns: z.number(),
    totalItems: z.number(),
    avgProcessingTimeHours: z.number(),
    comparisonTotalReturns: z.number(),
    comparisonTotalItems: z.number(),
    comparisonAvgProcessingTimeHours: z.number(),
  }),
};
